import React, {useEffect} from 'react'
import useCurrentUser from '#hooks/store/useCurrentUser'
import {useNavigate} from 'react-router-dom'
import {DEFAULT_PATH_NO_ROLE, defaultPathForRole} from '#helpers/defaultPathForRole'
import Loading from '#components/a/Loading'

export const LoginRedirect = () => {
  const {role, loginError} = useCurrentUser()
  const navigate = useNavigate()

  useEffect(() => {
    if (role) {
      navigate(defaultPathForRole(role))
    }
  }, [role])

  useEffect(() => {
    if (loginError) {
      navigate(DEFAULT_PATH_NO_ROLE)
    }
  }, [loginError])

  return <Loading />
}

export default LoginRedirect
